export default __webpack_public_path__ + "static/media/blue-star.02cb7c61.svg";